import * as actionTypes from "../../Constants/categoryActionTypes";
import { isEdited } from "../../actions/categories/isEdited";

const initialState = {
    edited: false,
    newCategoryAdded: false,
    showModal: {
        state: false,
        modalName: "Name",
        component: "",
        size: "small",
        submitBtn: "Submit",
        denyBtn: "Cancel",
        payload: {}
    },
    showLoader: false,
    categories: [],
    activeCategories: [],
    originalCategories: "",
    categoryTypes: ["TAX","Financial","CAS","Other","HR"]
}

const allCategories = ( state = initialState , action) => {
    //console.log("##########################", state, action);
    switch(action.type) {
        case actionTypes.FETCH_ALL_CATEGORIES : 
            return {
                ...state,
                categories: action.payload.categoryData,
                originalCategories: JSON.stringify(action.payload.categoryData),
                categoryTypes: state.categoryTypes
            }
        case actionTypes.FETCH_ACTIVE_CATEGORIES :
            return { 
                ...state,
                activeCategories: action.payload.categoryData
            }
        case actionTypes.RESET_ALL_CATEGORIES: {
            let originalCategories;
            try {
                originalCategories = state.originalCategories ? JSON.parse(state.originalCategories) : [];
            }
            catch (error) {
                console.error('Invalid JSON input:', error.message);
            }
            return {
                ...state,
                categories: originalCategories,
                edited: false,
            }
        }
        case actionTypes.SHOW_MODAL: 
            return {
                ...state,
                showModal: action.payload.showModal
            }
        case actionTypes.SHOW_LOADER:
            return {
                ...state,
                showLoader: action.payload.showLoader
            }
        case actionTypes.IS_EDITED:
            return {
                ...state,
                edited: action.payload.edited,
            }
        case actionTypes.SAVE_EDITS:
            return {
                ...state,
                categories: action.payload.categoryData,
                originalCategories: JSON.stringify(action.payload.categoryData),
                edited: false,
            }
        case actionTypes.ADD_CAT:
            return {
                ...state,
                categories: action.payload.categoryData,
                originalCategories: JSON.stringify(action.payload.categoryData),
                newCategoryAdded: true
            }
        default :
            return state
    }
}

export default allCategories

